import { createQueryClient } from "@sukha/query";

import Logger from "@/lib/utils/logger";

export const queryClient = createQueryClient({ logger: Logger });
